/* eslint-disable max-len */
import React from 'react';

const TextColorIcon = props => (
  <svg width={19} height={19} viewBox="0 0 19 19" {...props}>
    <path
      fill="currentColor"
      d="M12.9406953 8.95385441C12.1642734 9.88748434 11.6208213 10.7926967 11.3103388 11.6694915L7.40037874 11.6694915 6.54305663 13.9353876C6.52834357 13.9742741 6.49110424 14 6.4495274 14L4.09790277 14C4.04267429 14 3.99790277 13.9552285 3.99790277 13.9 3.99790277 13.8868237 4.00050674 13.8737773 4.00556503 13.8616107L8.4700421 3.12322131C8.50105957 3.04861511 8.5739205 3 8.65471758 3L10.3160943 3C10.396723 3 10.4694666 3.04841524 10.5005916 3.12279406L12.9406953 8.95385441zM9.41798529 6.20056497L8.13269519 9.61864407 10.7182206 9.61864407 9.41798529 6.20056497zM12 13.4245258C12 14.8207269 13.145 16 14.5 16 15.855 16 17 14.8202416 17 13.4245258 17 12.103093 16.2894438 10.6820365 14.8683313 9.16135614L14.8683089 9.16137708C14.6797751 8.95963399 14.3633932 8.94892574 14.1616501 9.13745952 14.1536124 9.144971 14.1458247 9.15274572 14.1382999 9.16077099 12.7127666 10.6811133 12 12.1023649 12 13.4245258z"
    />
  </svg>
);

export default TextColorIcon;
/* eslint-enable max-len */
